import styled from 'styled-components'

import { ItemExpandable as DefaultItemExpandable } from 'components/Lists'

export const ItemExpandable = styled(DefaultItemExpandable)`
	margin-left: 12px;
	width: calc(100% - 12px);
`
